import type { FC, ReactNode } from 'react'

import Image from 'next/image'
import SectionLabel from '@/components/landing/section-label'
import { STUDIO_STATS } from '@/constants/landing'

const StudioSection: FC = (): ReactNode => {
    return (
        <section id='studio' aria-labelledby='studio-title' className='site-container py-20 md:py-32'>
            <div className='grid gap-10 lg:grid-cols-12'>
                <div className='lg:col-span-3'>
                    <SectionLabel index='01'>
                        The studio
                    </SectionLabel>

                    <h2 id='studio-title' className='sr-only'>
                        About Wallop
                    </h2>
                </div>

                <div className='lg:col-span-9'>
                    <p className='reveal font-heading text-[clamp(2rem,4.4vw,4.5rem)] leading-[1.03] font-extrabold tracking-[-0.02em] text-pretty wdth-90'>
                        We’re a 24-person studio for{' '}
                        <span className='rounded-[0.2em] bg-pop-yellow px-[0.12em] [box-decoration-break:clone]'>
                            challenger brands
                        </span>
                        {' '}with something to say. The shelf is the loudest room on earth, so we design to win it: identities with a point of view, packs people{' '}
                        <span className='relative inline-block h-[0.8em] w-[1.45em] overflow-hidden rounded-full bg-pop-mint align-[-0.08em]'>
                            <Image
                                src='/images/work/grain-gang.png'
                                alt=''
                                fill
                                sizes='10rem'
                                className='object-cover object-[50%_40%]'
                            />
                        </span>
                        {' '}pick up, and renders so real you’ll{' '}
                        <span className='text-pop-orange'>reach for the screen.</span>
                    </p>

                    <dl className='mt-14 grid grid-cols-2 gap-x-6 gap-y-10 border-t-2 border-foreground pt-10 md:mt-20 lg:grid-cols-4'>
                        {STUDIO_STATS.map(stat => (
                            <div key={stat.label} className='reveal flex flex-col-reverse gap-3'>
                                <dt className='text-sm font-medium text-muted-foreground md:text-base'>
                                    {stat.label}
                                </dt>

                                <dd className='font-heading text-[clamp(3.5rem,7vw,6.5rem)] leading-[0.85] font-black tracking-[-0.02em] wdth-75'>
                                    {stat.value}
                                </dd>
                            </div>
                        ))}
                    </dl>
                </div>
            </div>
        </section>
    )
}

export default StudioSection
